// Copyright (c) StrangeBee 2024

import { ObjectTypeV1 } from 'thehive-sdk';

export const entitiesToExclude = [
    ObjectTypeV1.CATALOG_ATTACK_PATTERNS,
    ObjectTypeV1.ATTACK_PATTERNS,
    ObjectTypeV1.ANALYZER_TEMPLATE,
    ObjectTypeV1.ALERT_STATUS,
    ObjectTypeV1.CASE_STATUS,
    ObjectTypeV1.TAG,
    ObjectTypeV1.ANY,
    'case_artifact_job', //updated V0->V1
];
